import React from 'react'
import TreeSelect from 'components/TreeSelect'

// Note: This hardcoded data will be replaced by dynamic data from the API
const defaultSkillsOptions = [
  { title: 'JavaScript', value: 'javascript' },
  { title: 'Python', value: 'python' },
  { title: 'Java', value: 'java' },
  { title: 'React', value: 'react' },
  { title: 'Node.js', value: 'nodejs' },
  { title: 'SQL', value: 'sql' },
  { title: 'AWS', value: 'aws' },
  { title: 'Docker', value: 'docker' },
  { title: 'Git', value: 'git' },
  { title: 'Angular', value: 'angular' }
]

const SkillsFilter = ({ state, handleSkillsChange, checkSkills, skillsFilter}) => {
  // Convert the API format to the format expected by TreeSelect component


  return (
    <TreeSelect
      showArrow={true}
      filterTreeNode={false}
      treeCheckable={true}
      placeholder="Select Skills"
      maxTagCount={0}
      showSearch={true}
      treeDefaultExpandAll={true}
      removeTreeIndent={true}
      shadowBox
      onChange={handleSkillsChange}
      value={checkSkills}
      treeData={skillsFilter || []}
      height={'auto'}
      treeNodeFilterProp="title"
      autoClearSearchValue={false}
    />
  )
}

export default SkillsFilter
